import emailjs from 'emailjs-com';

export function sendRegistrationEmail({
  user_name,
  registration_number,
  user_email,
  user_type,
  name,
  email,
}) {
  if (!email) {
    throw new Error("Recipient email (email) is empty");
  }

  return emailjs
    .send(
      'service_d0dqafe',
      'template_x6yc1i5',
      {
        user_name,
        registration_number,
        user_email,
        user_type,
        name,
        email, // must match template variable!
      },
      'CwUBiyAh0zdC3QwU5'
    )
    .then(
      (result) => {
        console.log("EmailJS success:", result);
        alert("Registration email sent successfully!");
        return result;
      },
      (error) => {
        console.error("EmailJS error:", error);
        alert("Failed to send the registration email. Please try again.");
        throw error;
      }
    );
}